export const partnerData = [
  {
    id: '1',
    title: '合作区域',
    patter: [
      {
        icon:
          'https://img.alicdn.com/tfs/TB1yiQ.CAL0gK0jSZFtXXXQCXXa-116-116.png',
        title: '浙江省卫健委',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1rio.CAL0gK0jSZFtXXXQCXXa-106-117.png',
        title: '余杭卫健委',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1.s..CEz1gK0jSZLeXXb9kVXa-397-72.png',
        title: '郑州市卫生健康委员会',
        width: 10,
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1INhdCHj1gK0jSZFOXXc7GpXa-300-92.png',
        title: '桐庐县卫生健康局',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1dR8dCND1gK0jSZFyXXciOVXa-116-116.png',
        title: '巍山卫健',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1O5U_CpY7gK0jSZKzXXaikpXa-247-48.png',
        title: '天台医共体',
      },
    ],
  },
  {
    id: '2',
    title: '合作医疗机构',
    patter: [
      {
        icon:
          'https://img.alicdn.com/tfs/TB1KLVeCHj1gK0jSZFOXXc7GpXa-120-120.png',
        title: '浙大一院',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1VhA.CpY7gK0jSZKzXXaikpXa-129-123.png',
        title: '浙医二院',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1ONReCND1gK0jSZFyXXciOVXa-118-114.png',
        title: '杭州市一',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB19Ds.Cvb2gK0jSZK9XXaEgFXa-120-120.png',
        title: '浙江省肿瘤',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1CvFXCQL0gK0jSZFtXXXQCXXa-116-116.png',
        title: '浙江省新华',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1oOleCND1gK0jSZFyXXciOVXa-132-109.png',
        title: '建德医院',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1efpcCQY2gK0jSZFgXXc5OFXa-565-91.png',
        title: '中山医院',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1m6BdCNv1gK0jSZFFXXb0sXXa-102-121.png',
        title: '浙江省立同德 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1PHJeCND1gK0jSZFKXXcJrVXa-117-135.png',
        title: '浙江省血液中心',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1wy4eCND1gK0jSZFyXXciOVXa-478-110.png',
        title: '浙江省皮肤病研究所',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1ARtXCFP7gK0jSZFjXXc5aXXa-814-91.png',
        title: '德清医院 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1xkxcCO_1gK0jSZFqXXcpaXXa-116-116.png',
        title: '綦江人民医院 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1Xe4jCRr0gK0jSZFnXXbRRXXa-117-118.png',
        title: '重庆妇幼保健院 ',
      },
    ],
  },
  {
    id: '3',
    title: '集团生态',
    patter: [
      {
        icon:
          'https://img.alicdn.com/tfs/TB1NAYkFRr0gK0jSZFnXXbRRXXa-189-52.png',
        title: '阿里健康',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1dVfgFQT2gK0jSZFkXXcIQFXa-156-56.png',
        title: '支付宝',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1LP_eFHY1gK0jSZTEXXXDQVXa-189-43.png',
        title: '阿里云',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1e7faFFP7gK0jSZFjXXc5aXXa-150-59.png',
        title: '钉钉',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1ZOfeFNv1gK0jSZFFXXb0sXXa-152-25.png',
        title: '熙牛 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1BAYfFND1gK0jSZFyXXciOVXa-143-59.png',
        title: '淘宝 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1p6HbFUY1gK0jSZFMXXaWcVXa-163-56.png',
        title: '天猫 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1cSHeFHY1gK0jSZTEXXXDQVXa-149-52.png',
        title: '菜鸟 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB16gzeFND1gK0jSZFKXXcJrVXa-163-54.png',
        title: '高德 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB19N6hFHj1gK0jSZFuXXcrHpXa-126-52.png',
        title: '饿了么 ',
      },
      {
        icon:
          'https://img.alicdn.com/tfs/TB1S1PbFKT2gK0jSZFvXXXnFXXa-126-54.png',
        title: 'UC ',
      },
    ],
  },
];
